import { formatToDisplayTime } from "../../../utils/dateTimeUtils";

export const checkOutColumns = () => {
    return [
        { field: "studentId", headerName: "StudentID", width: 110 },
        {
            field: "studentName", 
            headerName: "Student Name", 
            width: 140,
            renderCell: (params) => {
                const studentName = `${params.row.firstName || ""} ${params.row.lastName || ""}`.trim();
                const userRole = params.row.role;
                const isStaffOrAdmin = userRole === 'STAFF' || userRole === 'ADMIN';
                if (isStaffOrAdmin) {
                    const roleDisplay = userRole === 'STAFF' ? '(staff)' : '(admin)';
                    return `${roleDisplay} ${studentName}`;
                }
                return studentName;
            }
        },
        { field: "checkOutDate", headerName: "Check-out Date", width: 125 },
        { field: "checkOutTime", headerName: "Check-out Time", width: 125,
            renderCell: (params) => {return formatToDisplayTime(params.row.checkOutTime)}
        },
    ];
};

export const checkInColumns = () => {
    return [
        { field: "studentId", headerName: "StudentID", width: 110 },
        {
            field: "studentName", 
            headerName: "Student Name", 
            width: 140,
            renderCell: (params) => {
                const studentName = `${params.row.firstName || ""} ${params.row.lastName || ""}`.trim();
                const userRole = params.row.role;
                const isStaffOrAdmin = userRole === 'STAFF' || userRole === 'ADMIN';
                if (isStaffOrAdmin) {
                    const roleDisplay = userRole === 'STAFF' ? '(staff)' : '(admin)';
                    return `${roleDisplay} ${studentName}`;
                }
                return studentName;
            }
        },
        { field: "checkInDate", headerName: "Check-in Date", width: 125 },
        { field: "checkInTime", headerName: "Check-in Time", width: 125,  
            renderCell: (params) => {return formatToDisplayTime(params.row.checkInTime)}
        },
    ];
};